import {React} from 'react';

import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

/*
 * Module - CopyRight.js
 *
 * Description : 화면 하단의 CopyRight 렌더링 모듈 
 *
 * 작성자 : Choi young ho. 
 * Created on Mon Jun 20 2022
 * Copyright (c) 2022 Renewhouse corp
 */
const CopyRight = (props) => {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://mui.com/">
                Your Website
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

export default CopyRight;